module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_1.c0568d50.png";